export default __webpack_public_path__ + "static/media/port2.49d6a0cb.jfif";